import {
  setDefaultLandingPage,
  setDefaultLandingPagePromptNeedInput,
  setDefaultLandingPagePromptTitle,
  setDefaultLandingPagePromptContent,
  setDefaultLandingPagePromptOkFn,
  showPrompt
} from '@store/defaultLandingPage/actions';

import getActualShareLink from '@components/common/Sharing/SharingModal/SharingContent/getActualShareLink';
import { setActiveDashboardId } from '@store/dashboards/ui/actions';

const onSetDefaultLandingApply = (dispatch, cid) => {
  const { pathname } = window.location;
  dispatch(setActiveDashboardId(null));
  const arr = pathname.split('/');
  const u = getActualShareLink(pathname, cid);
  dispatch(
    setDefaultLandingPage({
      url: u,
      name: arr[arr.length - 1],
      path: pathname
    })
  );
};

const onSetDefaultLanding = (dispatch, defaultLandingPage, cid) => {

  const dlpOkFn = () => onSetDefaultLandingApply(dispatch, cid);

  dispatch(setDefaultLandingPagePromptNeedInput(dlpNeedInput));
  dispatch(setDefaultLandingPagePromptTitle(dlpTitle));
  dispatch(setDefaultLandingPagePromptContent(dlpContent(defaultLandingPage)));
  dispatch(setDefaultLandingPagePromptOkFn(dlpOkFn));
  dispatch(showPrompt());
}

const dlpTitle = 'Make default';
const dlpContentChangeDefault =  'Are you sure you want to change your default dashboard?';
const dlpContentSetDefault =  'Are you sure you want to set your default dashboard?';
const dlpNeedInput = false;

const dlpContent = (defaultLandingPage) =>  {
  const hasDefaultLandingPage = defaultLandingPage.url.length > 0;
  return hasDefaultLandingPage ? dlpContentChangeDefault : dlpContentSetDefault
};

export {
  dlpTitle,
  dlpNeedInput,
  dlpContentChangeDefault,
  dlpContentSetDefault,
  onSetDefaultLanding,
  onSetDefaultLandingApply,
  dlpContent
};
